export type RegulationUiAction =
  | SetKidAccordion
  | SetMifidAccordion
  | SetTargetAccordion
  | SetTheoreticalValueAccordion;

export interface SetKidAccordion {
  type: 'SET_KID_ACCORDION';
  tabId: string;
  isOpen: boolean;
}
export function setKidAccordion(tabId: string, isOpen: boolean): SetKidAccordion {
  return {
    type: 'SET_KID_ACCORDION',
    tabId,
    isOpen,
  };
}

export interface SetMifidAccordion {
  type: 'SET_MIFID_ACCORDION';
  tabId: string;
  isOpen: boolean;
}
export function setMifidAccordion(tabId: string, isOpen: boolean): SetMifidAccordion {
  return {
    type: 'SET_MIFID_ACCORDION',
    tabId,
    isOpen,
  };
}

export interface SetTargetAccordion {
  type: 'SET_TARGET_ACCORDION';
  tabId: string;
  isOpen: boolean;
}
export function setTargetAccordion(tabId: string, isOpen: boolean): SetTargetAccordion {
  return {
    type: 'SET_TARGET_ACCORDION',
    tabId,
    isOpen,
  };
}

export interface SetTheoreticalValueAccordion {
  type: 'SET_THEORETICAL_VALUE_ACCORDION';
  tabId: string;
  isOpen: boolean;
}
export function setTheoreticalValueAccordion(tabId: string, isOpen: boolean): SetTheoreticalValueAccordion {
  return {
    type: 'SET_THEORETICAL_VALUE_ACCORDION',
    tabId,
    isOpen,
  };
}
